import React, { useState } from "react";
import { headingBlue, maroon, mediumGrey } from "../assets/colors";
import { Avatar, Box, Button, Divider, IconButton, Menu, MenuItem } from "@mui/material";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import { useLocation, useNavigate } from "react-router-dom";
import { logOut } from "../utils/commonFunctions";
import CustomDropDown from "./CustomDropDown";
import { adminDashboardsList, dashboardsList, districtHeadDashboardsList, stateHeadDashboardsList } from "../utils/constants";
import Countdown from "./Countdown";
import Memcard from "./membershipCard/memcard";
import { getMemCardStatus } from "../backend/backendApis";
import HttpService from "../backend/requestApis";
import UpdateWORKerDetails from "./WORKersManagement/UpdateWORKersDetails/updateWORKerDetails";
import WORKerProfileDialog from "./WORKersManagement/WORKerProfileDialog";
import Loader from "./Loader";

const HeaderBar = (props) => {

	const navigate = useNavigate();
	const location = useLocation();
	const dashboard = location.state || null;

	const [selectedDashboard, setSelectedDashboard] =
		React.useState("Daily Task");

	const [userIconStatus, setUserIconStatus] = useState(false)
	const [profileDialogOpen, setProfileDialogOpen] = useState(false)
	const [memCardStatus, setMemCardStatus] = useState(null)
	const [updateWORKerDetailsDialogStatus, setUpdateWORKerDetailsDialogStatus] = useState(false)
	const [memcardDialogStatus, setMemCardDialogStatus] = useState(false)
	const [chapterCode, setChapterCode] = useState(null)
	const [name, setName] = useState(null)
	const [id, setId] = useState(null)
	const [photoStatus, setPhotoStatus] = useState(null)
	const [gender, setGender] = useState(null)
	const [obligation, setObligation] = useState('WORKer')
	const [anchorEl, setAnchorEl] = React.useState(null);
	const [loader, setLoader] = useState(false)
	const [list, setList] = useState([])

	const open = Boolean(anchorEl);
	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};
	const handleClose = () => {
		setAnchorEl(null);
	};

	const updateDashboard = (dashBoard) => {
		setSelectedDashboard(() => dashBoard);
		props.setFunc(dashBoard)
	};

	// React.useEffect(() => {
	// 	if (props.isAdmin) {
	// 		setSelectedDashboard("Members");
	// 		setList(adminDashboardsList)
	// 	} else {
	// 		if (dashboard) {
	// 			setSelectedDashboard(() => dashboard?.dashboard);
	// 		} else if (!props.isReportForm) {
	// 			if(localStorage.getItem('designation') && localStorage.getItem('designation') === 'admin'){
	// 				setSelectedDashboard("Members");
	// 				props.setFunc("Members")
	// 				setList(adminDashboardsList)
	// 			} else 
	// 			if(localStorage.getItem('designation') && ['supervisor', 'incharge'].includes(localStorage.getItem('designation'))){
	// 				console.log(" I am inside::::::::::::::::")
	// 				setSelectedDashboard(() => "Daily Task");
	// 				props.setFunc("Daily Task");
	// 				var dList = dashboardsList

	// 				if(localStorage.getItem('isStateHead') === 'true'){
	// 					let updatedDList = [...dList, ...stateHeadDashboardsList]
	// 					.filter(
	// 						(obj, index, self) =>
	// 						  index === self.findIndex((o) => o.name === obj.name)
	// 					  );

	// 					dList = [...updatedDList]
	// 				}

	// 				if(localStorage.getItem('isDistrictHead') === 'true'){
	// 					let updatedDList = [...dList, ...districtHeadDashboardsList].filter(
	// 						(obj, index, self) =>
	// 						  index === self.findIndex((o) => o.name === obj.name)
	// 					  );
	// 					  dList = [...updatedDList]
	// 				}

	// 				console.log("dList: ", dList)
	// 				setList(dList)
	// 			} else {
	// 				setSelectedDashboard('WORKers')
	// 				props.setFunc('WORKers')

	// 				let dList = []

	// 				if(localStorage.getItem('isStateHead') === 'true'){
	// 					dList = stateHeadDashboardsList
	// 				}

	// 				if( localStorage.getItem('isDistrictHead') === 'true'){
	// 					if(dList?.length === 0){
	// 						dList = districtHeadDashboardsList
	// 					} else {
	// 						let updatedDList = [...dList, ...districtHeadDashboardsList].filter(
	// 							(obj, index, self) =>
	// 							  index === self.findIndex((o) => o.id === obj.id)
	// 						  );
	// 						dList = [...updatedDList]
	// 					}
	// 				}

	// 				setList(dList)
	// 			}

	// 		}
	// 	}
	// }, []);

	React.useEffect(() => {
		try {
			if (userIconStatus && localStorage.getItem('contact')) {
				setLoader(true)
				let options = {
					url: getMemCardStatus,
					method: 'GET',
					params: {
						// if ContactNumber is not present navigate to sigin.
						contactNumber: localStorage.getItem('contact')
					},
					headers: {
						Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : ''
					}
				}
				HttpService(options).then(resp => {
					setMemCardStatus(resp?.data?.data?.isMemCardGenerated)
					if (resp?.data?.data?.isMemCardGenerated) {
						setName(resp?.data?.data?.name)
						setChapterCode(resp?.data?.data?.chapterCode)
						setId(resp?.data?.data?.id)
						setPhotoStatus(resp?.data?.data?.photoStatus)
						setObligation(resp?.data?.data?.obligation)
						setMemCardDialogStatus(true)
					} else {
						setGender(resp?.data?.data?.gender)
						setChapterCode(resp?.data?.data?.chapterCode)
						setUpdateWORKerDetailsDialogStatus(true)
						setId(resp?.data?.data?.id)
					}
					setLoader(false)
				}).catch(err => {
					setLoader(false)
					if (err?.status === 403) {
						localStorage.clear();
						// setLoadingTableData(false);
						navigate("/signUp");
					} else {
						console.log('Error in getting mem card Status: ', err)
					}

				})
			} else {
				if (!localStorage.getItem('contact') && props.isReportForm) {
					navigate('/signUp')
				}
			}
		} catch (err) {
			setLoader(false)
			console.log('Error in checking mem card status: ', err)
		}
	}, [userIconStatus])

	var buttonStyle = {
		backgroundColor: headingBlue,
		color: "white",
		// marginRight: '0.2rem',
		marginLeft: "0.7rem",
		fontFamily: "Helvetica",
		fontWeight: "300",
		fontSize: "1rem",
		padding: "0rem 1rem 0rem 1rem",
	};
	return (
		<>
			{loader &&
				<Loader></Loader>
			}
			<nav
				className="navbar navbar-expand-lg"
				style={{ backgroundColor: mediumGrey, padding: '0.2rem 0rem 0.75rem 0rem' }}
			>
				<div
					className="container-fluid"
					style={{ padding: "0.5rem 2.5rem 0.5rem 0.5rem" }}
				>
					<Box style={{ display: "flex", alignItems: "center" }}>
						<Box
							style={{
								display: "flex",
								justifyContent: "flex-start",
								marginLeft: "1rem",
							}}
						>
							<Countdown targetDate={new Date("2065-08-31T23:59:59")} />
						</Box>
						<Box
							style={{
								display: "flex",
								justifyContent: "flex-start",
								width: "50%",
								marginLeft: "1rem",
							}}
						>
							{/* <img style={{width: "4rem", height: '2rem'}} src={require('../assets/images/WORK_logo.png')}></img> */}
						</Box>

						<Box
							style={{
								width: "50%",
								height: "2.5rem",
								display: "flex",
								justifyContent: "flex-end",
								alignItems: "flex-start",
								// border: '1px solid'

							}}
						>
							<a
								className="navbar-brand mx-auto"
								style={{
									fontSize: "1rem",
									color: mediumGrey,
									textAlign: "center",
									padding: "0.5rem",
								}}
							>
								"
							</a>
							{/* <Button variant='outlined' sx={buttonStyle} style={{ textTransform: 'capitalize' }}>Add Session</Button> */}
							{!props.isReportForm && (
								<>
									{/* <CustomDropDown
										width="10rem"
										regular={true}
										list={list}
										value={selectedDashboard}
										setFunc={updateDashboard}
									></CustomDropDown> */}

									<Button
										variant="outlined"
										sx={buttonStyle}
										style={{ textTransform: "capitalize" }}
										onClick={async () => {
											await localStorage.clear();
											if (props.isReportForm) {
												await logOut(navigate);
											} else {
												navigate("/Login");
											}
										}}
									>
										Logout
									</Button>
								</>)}
							{props.isReportForm &&
								// <Button
								// 	variant="outlined"
								// 	sx={{...buttonStyle, backgroundColor: maroon, borderColor: maroon}}
								// 	style={{ textTransform: "capitalize", height: "2rem", width: '2rem', borderRadius: "50%", minWidth: 0 }}
								// 	onClick={async () => {
								// 		setUserIconStatus(true)
								// 		// await localStorage.clear();
								// 		// if (props.isReportForm) {
								// 		// 	await logOut(navigate);
								// 		// } else {
								// 		// 	navigate("/");
								// 		// }
								// 	}}
								// >
								// 	{localStorage.getItem('prefix') ? localStorage.getItem('prefix'): ''}
								// </Button>
								<>
									<IconButton
										onClick={handleClick}
										size="small"
										sx={{ ml: 2 }}
										aria-controls={open ? 'account-menu' : undefined}
										aria-haspopup="true"
										aria-expanded={open ? 'true' : undefined}
									>
										<Avatar sx={{ backgroundColor: maroon }}>
											{localStorage.getItem('prefix') ? localStorage.getItem('prefix') : ''}
										</Avatar>
									</IconButton>
									<Menu
										anchorEl={anchorEl}
										id="account-menu"
										open={open}
										onClose={handleClose}
										onClick={handleClose}
										slotProps={{
											paper: {
												elevation: 0,
												sx: {
													overflow: 'visible',
													filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
													mt: 1.5,
													'& .MuiAvatar-root': {
														width: 32,
														height: 32,
														ml: -0.5,
														mr: 1,
													},
													'&::before': {
														content: '""',
														display: 'block',
														position: 'absolute',
														top: 0,
														right: 14,
														width: 10,
														height: 10,
														bgcolor: 'background.paper',
														transform: 'translateY(-50%) rotate(45deg)',
														zIndex: 0,
													},
												},
											},
										}}
										transformOrigin={{ horizontal: 'right', vertical: 'top' }}
										anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
									>
										<MenuItem
											onClick={() => {
												handleClose();
												setProfileDialogOpen(true);
											}}
											sx={{
												display: 'flex',
												alignItems: 'center',
												gap: 1,
												fontWeight: 600,
												color: headingBlue,
											}}
										>
											<PersonOutlineIcon sx={{ fontSize: 20, color: headingBlue }} />
											My Profile
										</MenuItem>
										<Divider sx={{ my: 0.5 }} />
										<MenuItem onClick={async () => {
											setUserIconStatus(() => true)
										}}	>
											Membership Card
										</MenuItem>
										<MenuItem onClick={async () => {
											await localStorage.clear();
											if (props.isReportForm) {
												await logOut(navigate);
											} else {
												navigate("/");
											}
										}}>
											Logout
										</MenuItem>

									</Menu>
								</>
							}
						</Box>
					</Box>
				</div>
			</nav>
			<Memcard memcardDialogStatus={memcardDialogStatus}
				updatememCardDialogStatus={() => {
					setMemCardDialogStatus(!memcardDialogStatus)
					setUserIconStatus(() => false)
				}}
				name={name}
				chapterCode={chapterCode}
				id={id}
				photoStatus={photoStatus}
				obligation={obligation}
			></Memcard>
			<UpdateWORKerDetails wORKerDetailsDialogStatus={updateWORKerDetailsDialogStatus} updateWORKerDetailsDialogStatusFunc={() => {
				setUpdateWORKerDetailsDialogStatus(!updateWORKerDetailsDialogStatus)
				setUserIconStatus(() => false)
			}}
				chapterCode={chapterCode}
				gender={gender}
				id={id}
			></UpdateWORKerDetails>
			<WORKerProfileDialog
				open={profileDialogOpen}
				onClose={() => setProfileDialogOpen(false)}
			/>
		</>
	);
};

export default HeaderBar;
